'use strict'

module.exports = text

var u = require('unist-builder')
var trimLines = require('trim-lines')

/* Transform text. */
function text(h, node) {
  return h.augment(node, u('text', trimLines(node.value)))
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/text.js
// module id = 905
// module chunks = 95715928098905 168707334958949